import axios from 'axios';

const baseApi = axios.create({
    baseURL: `${process.env.VUE_APP_RUTA_API}api/`
})

export default baseApi